import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const LayoutRowIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path
          clipRule="evenodd"
          d="M19 11V5H5V11H19ZM19 13H5V19H19V13ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  },
);

export default LayoutRowIcon;
